module.exports = __webpack_public_path__ + "img/ALL-COVER.a2a113ce.png";